import React from 'react';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import HtmlParser from 'html-react-parser';
import { DemoFormLong } from '../../../components/DemoFormLong.jsx';
import CaseStudyHero from '../../../components/CaseStudyHero';
import UserTestimonyCardNoLogo from '../../../components/cards/UserTestimonyCardNoLogo';
import JoinHappyCustomers from '../../../components/JoinHappyCustomers';
import '../../../scss/pages/_customer-story-page.scss';
import { PATHS } from "../../../utils/urls";

const Resources = (props) => {

	return (
		<Layout bodyClass="customer-story-page invision-story-page" ontouchstart>
			<SEO title="Case Study: Rémy Cointreau | ChartHop | The Org Management Platform" />
			<Helmet>
				<meta
					name="description"
					content="Rémy Cointreau needed a tool to empower their HR deparment. ChartHop helped them work at a higher efficiency rate and deliver quicker and more streamlined insights."
				/>

				<meta property="og:url" content="https://www.charthop.com/resources/customers-stories/remy-cointreau" />
				<meta property="og:description" content="Rémy Cointreau needed a tool to empower their HR deparment. ChartHop helped them work at a higher efficiency rate and deliver quicker and more streamlined insights." />
				<meta property="og:image" content={`https://www.charthop.com/home/charthop-facebook.jpg`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="Case Study: Rémy Cointreau | ChartHop | The Org Management Platform" />
				<meta name="twitter:description" content="Rémy Cointreau needed a tool to empower their HR deparment. ChartHop helped them work at a higher efficiency rate and deliver quicker and more streamlined insights." />
				<meta name="twitter:image" content={`https://www.charthop.com/home/charthop-twitter.jpg`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
			</Helmet>

            <CaseStudyHero
                name="Rémy Cointreau"
                title="Unleashing HR’s strategic power"
                logo="/customers/customer-stories/logos/svg/remy-cointreau.svg"
                titlePosition="top"
				background="/customers/customer-stories/background-hero.png"
				pdfUrl="/customers/remy-case-study.pdf"
				caseStudySource="customers-invision-PDF-case-study-header"
            />

			{/* USER TESTIMONY SECTION*/}
			<section className="text-left flex-centeredColumn sectionSpacing backgroundGradientContainer-Reverse" id="Testimony">
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer"> 
				<UserTestimonyCardNoLogo
						testimony={HtmlParser('<p>“ChartHop allowed us to be a better partner to the business, It enabled us to work at a higher efficiency rate and deliver quicker and more streamlined insights.”</p>')}
						name="Joe Taranto"
						position="HR Generalist & Project Manager @ Rémy Cointreau"
						image="/customers/remy/joe-taranto.jpg"
						cardColor="#FFFFFF"
					/>
				</div>
			</section>			

			{/*Before ChartHop Section */}
			<section className="before-charthop-section sectionSpacing">
				<div className="container pt-3 pb-5">					
					<div  className="row pt-3 pt-mt-4 pt-lg-5">
						{/*Before Charthop COl */}
						<div className="col-md-7 col-lg-6">
							<div className="mr-md-2">
								<h2>Insights hidden by manually-intensive work</h2>
								<p>
								When Joe joined Rémy Cointreau’s HR team two years ago, he was tasked with managing the - at the time - over 200 person org chart. And he was doing it all manually in powerpoint. 
								</p><p> 
								So much time was spent dragging around boxes and shuffling people and teams across slides to be legible at meetings and presentations. 
								</p><p> 
								Joe was spending <strong>4-5 hours a week</strong> manually updating the org chart. Beyond costing <strong>$15K a year in productivity losses</strong>, it was also preventing him from sharing key people insights in a timely manner. 
								</p><p> 
								Rémy Cointreau needed a solution that enabled them to visually represent their company, keep pace with organizational changes, securely house their data, and align their teams to one source of truth for that data.
								</p><p>
									That’s when ChartHop came in. 
								</p>
							</div>
						</div>

						{/*About Mongo can COl */}
						<div className="containerAbout col-md-5 col-lg-6" >	          
							<div className="flex-centeredColumn contentBlock background-about">
								<h4 className="h4-big"><strong>About: </strong></h4>
								<img src={'/customers/remy/remy-cointreau-logo-white.svg'} alt="Even Financial" style={{margin: `auto`, maxWidth: 200}}/>
								<h4 className="h4-big"><strong>-</strong></h4>
								<h4><strong>Founded:</strong> 1990</h4>
								<h4><strong>Industry:</strong> Wine and Spirits</h4>
								<h4><strong>Type:</strong> Public</h4>
								<h4><strong>Number of Employees:</strong> 229</h4>
								<h4 className="h4-padding-bottom"><strong>Fully Distributed</strong></h4>
							</div><br/><br/>

							<h4 className="text-center"><strong>Rémy Cointreau was wasting: </strong></h4>
							<br/>
							<div className="flex-centeredColumn contentBlock">
								<div className="flex-platform svg-info-beforeChartHop">
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/time2.svg '} alt="Visualize" />
										<p>Time</p>
									</div>
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/money.svg'} alt="Put a face to the name" />
										<p>Money</p>
									</div>
									<div className="svg-info-card-3col2 ">
										<img src={'/product/org-chart/productivity2.svg'} alt="Time Saving" />
										<p>Productivity</p>
									</div>        
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* USER TESTIMONY SECTION*/}
			<section className="text-left flex-centeredColumn sectionSpacing backgroundGradientContainer" id="Testimony">
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer"> 
					<UserTestimonyCardNoLogo
						testimony={<p>	
						“When a VP or director of a team needed an org chart - and if they weren’t already fully updated - we just couldn’t provide it on the spot.”
						</p>}
						name="Joe Taranto"
						position="HR Generalist & Project Manager @ Rémy Cointreau"
						image="/customers/remy/joe-taranto.jpg"
						cardColor="#FFFFFF"
					/>
				</div>
			</section>

			{/* With ChartHop Section */}
			<section className="with-charthop-section sectionSpacing">
				<div className="container pt-3 pb-5">					
					<div className="row pb-3 pb-md-4 pb-lg-5 pt-3 pt-mt-4 pt-lg-5">
						{/* With Charthop COl */}
						<div className="col-md-7 col-lg-6">
							<div className="mr-md-2">
								<h2>
								Leveraging time-savings for strategic insights  
								</h2>
								<p>
									When Joe started working in ChartHop just over a year ago, he immediately experienced the benefits of the platform. 
								</p><p>
									He finally had a tool that allowed him to spend less time and energy on manual, administrative work and more time <strong>using the data to drive strategic insights for the business.</strong> 
								</p><p>
									And Joe isn’t letting any moment of his freed up time go to waste. “ChartHop allows me to focus on important projects like recruiting, workforce planning, and internal trainings. <strong>It just allows me to do my job.”</strong> 
								</p>
							</div>
						</div><br/>

						{/* Now InVision can COl */}
						<div className="containerNow col-md-5 col-lg-6" >		          
							<div className="flex-centeredColumn contentBlock background-withCharthop">
							<h4 className="text-center"><strong>Now Rémy Cointreau can:</strong></h4>
								<div className="flex-platform svg-info2-withCharthop">
									<div className="svg-info-card-3col2">
										<img src={'/customers/remy/org-chart-as-a-source.svg'} alt="Org Chart" />
										<p>Use their org chart as a source of truth</p>
									</div>
									<div className="svg-info-card-3col2">
										<img src={'/customers/remy/align-teams-to-hiring-plans.svg'} alt="Align Teams" />
										<p>Align teams to hiring plans</p>
									</div>
									<div className="svg-info-card-3col2 people-width">
										<img src={'/customers/remy/plan-more.svg'} alt="Plan Strategically" />
										<p>Plan more strategically </p>
									</div>
									<div className="svg-info-card-3col2">
										<img src={'/customers/remy/design-their-company-with-intention.svg'} alt="Design with intention" />
										<p>Design their company with intention</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/*Bullets Section */}
					<div className="sectionSpacing flex-centeredColumn with-charthop-section">
						<div className="contentBlock">
							<h4 className="text-center">Before ChartHop, Taranto was spending hours manually inputting employee data into PowerPoint. Rémy Cointreau’s headcount planning was disjointed and lacked clarity. These complex and manually-intensive processes left him wondering:</h4>
							<div className="flex-centeredColumn contentBlock">
								<div className="pgc1">
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p className="text-left">How to align his team to the same hiring plan?</p>
										</div>
									</div>
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p>How to visualize his workforce to drive insights for his teams?</p>
										</div>
									</div>
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p>How to design the company with intention?</p>
										</div>
									</div>
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p>How to better act as a strategic partner for the business?</p>
										</div>
									</div>
								</div>
							</div>
							<p className="text-center pb-3">
							ChartHop didn’t just offer robust org chart and planning capabilities, it also
							<strong className="p-lightblue"> saved $450K in reduced headcount spend.</strong></p>
						</div>
						<div className="">
							<center><a className="button button-withCharthop" rel="noopener noreferrer" target="_blank" href={PATHS.OVERVIEW}>START SAVING</a></center>
						</div>
					</div>
				</div>
			</section>

			{/* USER TESTIMONY SECTION */}
			<section className="text-left flex-centeredColumn sectionSpacing backgroundGradientContainer-Reverse" id="Testimony">
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer"> 
					<UserTestimonyCardNoLogo
						testimony={HtmlParser('<p>“ChartHop is like a digital playground where we can come up with plans and see their impact on our business in real time,” Joe explains. “What previously would have been discussed in a back-and-forth email thread, a powerpoint, a drawing, is now presented in a way that enables our team to propose changes that propel our business forward.” </p>')}
						name="Joe Taranto"
						position="HR Generalist & Project Manager @ Rémy Cointreau"
						image="/customers/remy/joe-taranto.jpg"
						cardColor="#FFFFFF"
					/>
				</div>
			</section>		

			{/* TRUSTED */}
			<section className="customer pt-8 pb-5">
				<JoinHappyCustomers title={HtmlParser('Trusted <span class="blue-text">by</span>')}></JoinHappyCustomers>
            </section>			

			{/* LONG FORM */}			
            <section name="request-demo" id="request-demo" className="request-demo pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"customers-invision-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">“ChartHop allows me to focus on important projects like recruiting, workforce planning, and internal trainings. <strong>It just allows me to do my job.”</strong><br/> The platform is user friendly, interactive and one of best tools I have ever used in my career!</p><div class="authorTag"><img src="/customers/remy/joe-taranto.jpg" class="testimonialAuthor" alt="Joe Taranto" /><div><p class="contactAuthor"><strong>Joe Taranto</strong> <br>HR Generalist & Project Manager @ Rémy Cointreau</p></div></div>')}/>
			</section>
		</Layout>
	);
};


export default Resources;